import React, { Component } from "react";

import ContentLoader from "react-content-loader";
import LazyLoad from "react-lazyload";
import { NavLink } from "react-router-dom";
import Ink from "react-ink";
import axios from "axios";
import DelayLink from "../../../helpers/delayLink";
import Fade from "react-reveal/Fade";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import ProgressiveImage from "react-progressive-image";
import "slick-carousel/slick/slick-theme.css";
class PromoSliderV2 extends Component {
    state = {
        tags : [],
        dots : true,
    };

    componentDidMount(){
    
    }

    componentWillReceiveProps(nextProps){
       if(nextProps.tags != 'undefined' &&  nextProps.tags && nextProps.tags.length > 6){
            this.setState({dots: false, tags: nextProps.tags})
       }

    }

    render() {

        const settings = {
			dots:  true,
			speed: 500,
			adaptiveHeight: false,
			autoplay: false,
			fade: false,
            arrows : false,

			slidesToShow: 1.4,
			infinite: false,
			
			
			};
		return (
            <React.Fragment >
          
          {this.state.tags && this.state.tags.length > 0 &&(
                <Slider {...settings} >
                {this.state.tags.map(tag => (
                    <DelayLink className="pr-4 mt-2 " to={"../" + tag.url}>
                        <div className="text-center" key={tag.id}>
                           
                            <ProgressiveImage
						delay={100}
                        src={localStorage.getItem('cdn')+ tag.data.image}
						placeholder={'https://res.cloudinary.com/swiggy/image/upload/fl_lossy,f_auto,q_auto/portal/m/blue_placeholder'}
					>
						{(src, loading) => (
						 <img style={{
							borderRadius: '8px',
							height: 'auto',
							width: '100%'
						}} 
							
						 src={src}/>
						)}
					</ProgressiveImage>	
                        </div>
                        </DelayLink>
                ))}
                </Slider>
            )}
            </React.Fragment>
        );
    }
}

export default PromoSliderV2;